import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import successToast from "../../components/helper-components/success-toast";
import errorToast from "../../components/helper-components/error-toast";
import { backendConfigResetAction } from "../../redux/actions/sales-action";

export default function Logout() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const sessionExpired = sessionStorage.getItem("sessionExpired");
    sessionStorage.removeItem("sessionExpired");
    localStorage.clear();
    // localStorage.clear() drops the cached /backend/config, but this route is
    // reached by a client-side navigate on a manual logout — the redux store is
    // never torn down. Reset the feature flags explicitly so the next user
    // starts from "unknown" and waits for a fresh /backend/config.
    dispatch(backendConfigResetAction());
    navigate("/login");
    if (sessionExpired) {
      errorToast("Session expired");
    } else {
      successToast("Logged Out Successfully");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
